export const onboardingConstants = {
  SET_FULL_NAME: 'SET_FULL_NAME',
  SET_PHONE_NUMBER: 'SET_PHONE_NUMBER',
  TOGGLE_PROFESSION: 'TOGGLE_PROFESSION',
  TOGGLE_SOFTWARE: 'TOGGLE_SOFTWARE',
  TOGGLE_MARKETING: 'TOGGLE_MARKETING',
  CLEAR_SOFTWARE: 'CLEAR_SOFTWARE',
};
